import { memo } from 'react'
import { useCountdown } from '@/hooks/useCountdown'
import './CountDown.less'
const CountDown = ({ startText = '开学钜惠  充值限时5折起', endText = '后结束', period = 1, showDays = false }: any) => {
  const {
    time: { days, hours, minutes, seconds, milliseconds }
  } = useCountdown(period)
  return (
    <div className='CountDown-container'>
      <span className='CountDown-startText'>{startText}</span>
      {showDays && (
        <>
          <label>{days}</label>天
        </>
      )}
      <label>{hours}</label>:<label>{minutes}</label>:<label>{seconds}</label>:<label>{milliseconds}</label>
      <i>{endText}</i>
    </div>
  )
}

export default memo(CountDown)
